export default "__VITE_ASSET__KoY$zHWX__"